import React from 'react';
import { Global, css } from '@emotion/react';
import Helmet from 'react-helmet';
import useSiteMetadata from '../hooks/use-sitemetadata';
import MaterialAppBar from './material-app-bar.js';
import {
  createTheme,
  responsiveFontSizes,
  ThemeProvider,
} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const MaterialUILayout = ({ children }) => {
  const { title, description } = useSiteMetadata();

  let theme = createTheme({
    palette: {
      primary: {
        main: '#FFD',
      },
      secondary: {
        main: '#ddf',
      },
      tertiary: {
        main: '#fc3',
      },
      background: {
        paper: 'transparent',
      },
      text: {
        primary: '#eee',
        secondary: '#aaa',
      },
    },
    typography: {
      h1: {
        fontSize: '2rem',
      },
      h2: {
        fontSize: '1.3rem',
      },
      h3: {
        fontSize: '1.1rem',
      },
      h4: {
        fontSize: '1.1rem',
      },
      h5: {
        fontSize: '1rem',
      },
      button: {
        fontSize: '1rem',
        textTransform: 'none',
      },
      body1: {
        fontSize: '1rem',
      },
      body2: {
        fontSize: '1rem',
      },
    },
  });
  theme = responsiveFontSizes(theme);

  return (
    <div
      className="container"
      css={css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 100vh;
        width: 100vw;
      `}
    >
      <Global
        styles={css`
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
        

        /* * + * {
          margin-top: 1rem;
        } */

        html,
        body {
          background: #000;
          height: 100%;
          margin: 0;
          color: #bbb;
          font-family: Roboto, "Segoe UI", -apple-system, Helvetica, Arial,
            sans-serif;
          font-size: 18px;
          line-height: 1.4;
          display:flex;
          overflow-x: hidden;
          overflow-y: auto; 
          /* remove margin for the main div that Gatsby mounts into */
          > div {
            margin-top: 0;
          }
         
         
          h1,
          h2,
          h3,
          h4,
          h5,
          h6 {
            color: #eee;
            line-height: 1.3rem;

            + * {
              margin-top: 0.5rem;
            }
          }
          h1 {
            line-height: 1.8rem;
          }

          strong {
            color: #eee;
          }

          li {
            margin-top: 0.25rem;
          }
        }

        footer,
        header {
          width: 100vw;
          /* background: #222; */
           '& > h1' {
            margin: 0;
          }
        }
        footer{
      
      
         },
      `}
      />
      <Helmet>
        <html lang="en" />
        <title>{title}</title>
        <meta name="description" content={description} />
      </Helmet>
      <ThemeProvider theme={theme}>
        <MaterialAppBar />

        <main
          css={css`
            margin: 1rem;
            width: 95vw;
          `}
        >
          <div className="content" css={css``}>
            {children}
          </div>
        </main>

        <footer
          className="footer"
          css={css`
            display: flex;
            justify-content: center;

            align-items: center;
          `}
        >
          <Typography variant="body2" color="textPrimary">
            ©Copyright 2021, Masumi Hayashi Foundation
          </Typography>
        </footer>
      </ThemeProvider>
    </div>
  );
};

export default MaterialUILayout;
